const pushToDataLayer = (...args) => {
  const customWindow = window;
  if (!customWindow.dataLayer) {
    return;
  }
  customWindow.dataLayer.push(...args);
};
export {
  pushToDataLayer
};
